module.exports = __webpack_public_path__ + "static/img/ent-91.bb9e1d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-91.jpg
// module id = mpqS
// module chunks = 51